export const WORKSPACE_STOCK_COLORS = [ '#540d6e', '#ee4266', '#ffd23f', '#3bceac', '#43aa8b', '#118ab2', '#073b4c' ];
